import { log } from "../../utils";
export class Animate {
    constructor(page) {
        this.page = page;
        this.enabled = false;
        this.watchList = new Map();
        this.unhook = () => { };
    }
    track() {
        try {
            this.untrack();
            const self = this;
            const proto = this.page.getWindow().Element.prototype;
            const originalAnimate = proto.animate;
            proto.animate = function (...args) {
                const animation = originalAnimate.apply(this, args);
                if (self.enabled) {
                    setTimeout(() => {
                        self.watch(animation);
                    }, 0);
                }
                return animation;
            };
            this.unhook = () => {
                this.unhook = () => { };
                this.watchList.clear();
                proto.animate = originalAnimate;
            };
            this.enabled = true;
        }
        catch (ex) {
            log(ex);
        }
    }
    untrack() {
        this.unhook();
        this.enabled = false;
    }
    add(target) {
        var _a, _b;
        const anims = (_b = (_a = target.getRootNode()).getAnimations) === null || _b === void 0 ? void 0 : _b.call(_a);
        if (anims)
            for (const animation of anims) {
                this.watch(animation);
            }
    }
    watch(animation) {
        var _a, _b;
        const properties = (_b = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.getKeyframes()) === null || _b === void 0 ? void 0 : _b.reduce((acc, kf) => (Object.assign(Object.assign({}, acc), kf)), {});
        if (properties) {
            this.watchList.set(animation, {
                state: null,
                properties: Object.keys(properties),
            });
        }
    }
    flush() {
        const changes = { styles: {} };
        let hasChanges = false;
        this.watchList.forEach((details, animation) => {
            var _a, _b;
            var _c;
            try {
                if (animation.playState === details.state) {
                    if (animation.playState === "idle") {
                        this.watchList.delete(animation);
                    }
                    return;
                }
                details.state = animation.playState;
                const target = (_a = animation.effect) === null || _a === void 0 ? void 0 : _a.target;
                const targetId = this.page.idp.getId(target);
                if (!targetId)
                    return;
                const styles = getComputedStyle(target);
                (_b = (_c = changes.styles)[targetId]) !== null && _b !== void 0 ? _b : (_c[targetId] = {});
                for (const property of details.properties) {
                    const value = styles.getPropertyValue(property);
                    if (value) {
                        changes.styles[targetId][property] = value;
                        hasChanges = true;
                    }
                }
            }
            catch (error) {
                log(error);
            }
        });
        return hasChanges ? changes : null;
    }
}
//# sourceMappingURL=animate.js.map